import Authenticated from '@/Layouts/Authenticated'
import { Inertia } from '@inertiajs/inertia'
import { Link } from '@inertiajs/inertia-react'
import React from 'react'
import Swal from 'sweetalert2'
import BranchOfficeItem from '@/Components/BranchOffice/Index/BranchOfficeItem'

const BranchOffice = ({ store, branch_offices, ...props }) => {

    const handleDelete = (office) => {
        Swal.fire({
            title:'Eliminar sucursal',
            html: `<strong>¡ADVERTENCIA!</strong>
                <p>Borrar una sucursal provocará el borrado de todos los registros de órdenes asignados.</p>
                <p>¿Está seguro de borrar la sucursal <strong>${office.name}</strong>?</p>`,
            confirmButtonText:'Si, eliminar la sucursal',
            confirmButtonColor: '#ff0000',
            cancelButtonText:'Cancelar.',
            showCancelButton:true,
        }).then((result) => {
            if(result.isConfirmed){
                Inertia.delete(route('branch-office.destroy', {office: office.slug}))
            }
        })
    }


    return (
        <Authenticated
            store={store}
            branchOffice={props.office}
            auth={props.auth}
            errors={props.errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight flex justify-between">
                <p>Sucursales <span className="capitalize">{store}</span></p>
                <Link href={route('branch-office.create')} className="px-3 py-2 bg-primary text-white rounded text-sm">Agregar nueva sucursal</Link>
            </h2>}
        >
            <div className="max-w-7xl flex flex-col sm:flex-row py-12 px-3 sm:px-6 lg:px-8 gap-8 mx-auto">
                {
                    branch_offices.length >= 1 && (
                        <div className="sm:w-4/5 flex-col flex gap-3">
                            {
                                branch_offices && branch_offices.map((office, key) => (
                                    <BranchOfficeItem {...office} key={key} />
                                ))
                            }
                        </div>
                    )
                }
                {
                    branch_offices.length <= 0 && (
                        <div className="flex flex-col justify-center items-center mx-auto w-full">
                            <h2 className="mb-4 text-xl font-bold text-gray-600">No hay sucursales creadas</h2>
                            <Link href={route('branch-office.create')} className="px-3 py-2 bg-primary text-white rounded text-sm">Agregar nueva sucursal</Link>
                        </div>
                    )
                }
            </div>
        </Authenticated>
    )
}

export default BranchOffice
